var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-view"},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{attrs:{"src":_vm.$env.getAppLogo().signet}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }